import { useEffect, useState } from 'react'

import { RefreshIFrameMessage, TopWindowMessage } from '../lib/types'
import { handleTopWindowMessage } from '../lib/utils'

export function RefreshApp(): null {
  const [_, setTimerId] = useState<number>()

  useEffect(() => {
    const listener = (event: MessageEvent<TopWindowMessage>): void => {
      setTimerId((timerId) => handleTopWindowMessage(event.data, timerId))
    }
    window.addEventListener('message', listener)
    return () => window.removeEventListener('message', listener)
  }, [])

  useEffect(() => {
    const { hash, pathname } = window.location
    if (pathname !== '/sign-in') {
      return
    }

    const message: RefreshIFrameMessage = { hash, source: 'ha-refresh-iframe' }
    window.top?.postMessage(message, '*')
  }, [])

  return null
}
